// src/Molecules/MoleculePaginationSimple/MoleculePaginationSimple.js
// Molecule : Composant qui gère la pagination avec les boutons "Précédent" et "Suivant".

import React from 'react';
import PropTypes from 'prop-types';
import AtomButtonSimple from '../../Atoms/AtomButtonSimple/AtomButtonSimple';

const MoleculePaginationSimple = ({ currentPage, totalPages, onPrevious, onNext }) => {
  return (
    <div className="paginationSimple d-flex justify-content-end align-items-center mt-4 px-4 gap-3">
      <AtomButtonSimple onClick={onPrevious} disabled={currentPage === 1} className="custom-prev-button">
        {/*Précédente*/} <span className="triangle-left"></span>
      </AtomButtonSimple>
      <span className="text-sm ml-5 mr-5"> {currentPage} sur {totalPages} </span>
      <AtomButtonSimple onClick={onNext} disabled={currentPage === totalPages} className="custom-next-button">
        {/*Suivante*/} <span className="triangle-right"></span>
      </AtomButtonSimple>
    </div>
  );
};

// Validation des props
MoleculePaginationSimple.propTypes = {
  currentPage: PropTypes.number.isRequired, // Page actuelle, obligatoire
  totalPages: PropTypes.number.isRequired,  // Nombre total de pages, obligatoire
  onPrevious: PropTypes.func.isRequired,    // Callback pour bouton "Précédent", obligatoire
  onNext: PropTypes.func.isRequired,        // Callback pour bouton "Suivant", obligatoire
};

export default MoleculePaginationSimple;
